import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CargandoService {

  public isLoading : Subject<any> = new Subject();


  public setLoading(flat) {
    this.isLoading.next(flat);
  }

  constructor() { }
}
